import { InjectionToken } from '@angular/core';

export const SERVICE_WORKER_USER_ID_FACTORY = new InjectionToken<() => Promise<string>>('SERVICE_WORKER_USER_ID_FACTORY');
